<template>

    <div class="card">
       <div class="card-body m-2">
          <div class="row p-2">
             <div class="d-row d-flex align-items-center">
 
                <div class="col-3">
                   <input v-model.trim="search" type="text" class="form-control form-control-sm" placeholder="🔍 Search organisation, contact name, email or phone...." 
                      style="border-radius:40px;font-size: 14px; font-family: 'Roboto', sans-serif;" 
                      @keyup="onSearch()"/>
                </div>
 
                <div class="ms-2 col-2">
                   <button type="button" class="fw-bold btn btn-info text-light btn-sm" style="font-size: 14px; width: 185px;"
                      data-bs-toggle="modal" data-bs-target="#leadForm" @click="onButtonClick('create', '')">
                      Create Block
                   </button>
                </div>
 
 
                <!-- FILTERS -->
                <div class="col-7 d-flex flex-row justify-content-end">
 
                   <div class="d-flex flex-row align-items-center">
                      <span class="p-2 filterTitle">Sort by:</span>
                      <select v-model="sortBy" class="form-select shadow-none filterOptions" 
                            style="width:auto;border:none">
                         <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{sortBy.text}}</option>
                      </select>
                   </div> 
 
                   <div v-if="sortBy == 'status' " class="d-flex flex-row align-items-center">
                      <span class="p-2 filterTitle">Filter {{ sortBy.text }} by:</span>
                      <select v-model="filterByStatus" class="form-select shadow-none filterOptions" 
                            style="width:auto;border:none">
                            <option value="none" selected>All</option>
                            <option v-for="status in leadStatusTypes" :key="status.id" :value="status.id">{{ status.display_name }}</option>
                      </select>
                   </div> 
 
                   <div v-if="sortBy == 'priority'" class="d-flex flex-row align-items-center">
                      <span class="p-2 filterTitle">Filter {{ sortBy.text }} by:</span>
                      <select v-model="filterByPriority" class="form-select shadow-none filterOptions" 
                            style="width:auto;border:none">
                            <option value="none" selected>All</option>
                            <option v-for="priority in leadPriorityTypes" :key="priority.id" :value="priority.id">{{ priority.display_name }}</option>
                      </select>
                   </div> 
 
                   <div class="d-flex flex-row align-items-center">
                      <span class="p-2 filterTitle">Rows per page:</span>
                      <select v-model="pagination.pageSize" class="form-select form-select-sm shadow-none filterOptions" 
                            style="width:60px;border-color:#00A0C1;border-radius:10px;text-align: center;" >
                         <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{row.text}}</option>
                      </select>
                   </div>
                </div>
                 <!-- END FILTERS -->
                
             </div>
          </div>
             
          <div class="row p-2">
             <table class="table align-middle mainTable">
             
                <thead class="align-middle"> 
                   <tr>
                      <th scope="col" v-for="header in headers" :key="header.value">{{ header.text }}</th>
                   </tr>
                </thead>
 
                <tbody v-if="this.pagination.totalItems <= 0">
                   <tr>
                      <td colspan="4">
                         No records to display.
                      </td>
                   </tr>
                </tbody>
 
                <tbody>
                   <tr v-for="(lead) in leads" :key="lead.id" class="clickable-row">
                      <td @click="onButtonClick('view',lead.id)" data-bs-toggle="offcanvas" data-bs-target="#leadSidebar" aria-controls="leadSidebar">{{ formatDate(lead.date_created) }}</td>
                      <td @click="onButtonClick('view',lead.id)" data-bs-toggle="offcanvas" data-bs-target="#leadSidebar" aria-controls="leadSidebar">{{ lead.organisation_name }}</td>
                      <td @click="onButtonClick('view',lead.id)" style="color: #00A0C1" data-bs-toggle="offcanvas" data-bs-target="#leadSidebar" aria-controls="leadSidebar">{{ lead.lead_type_id }}</td>
                      <td>
                         <select class="form-select table-select shadow-none" :class="priorityClass(lead.lead_priority_id)" v-model="lead.lead_priority_id"
                            @focus="$refs.popover.closePopover" @change="updateLeadPriority($event, lead.id, lead.lead_priority_id)" 
                            data-bs-toggle="popover" tabindex="-1">
                            <option v-for="priority in leadPriorityTypes" :key="priority.id" :value="priority.id">{{ priority.display_name }}</option>
                         </select>
                      </td>
                      
                      <td> 
                         <select class="form-select table-select shadow-none" v-model="lead.lead_status_id" @focus="$refs.popover.closePopover"
                            @change="leadStatusChange($event, lead.id, lead.lead_status_id)" data-bs-toggle="popover" tabindex="-1">
                            <option v-for="status in leadStatusTypes" :key="status.id" :value="status.id">{{ status.display_name }}</option>
                         </select>
                      </td>
                      
                      <td> 
                            <VueMultiselect id="authOrganisation" class="auth-org-select" v-model="lead.lead_auth_organisation" 
                               @open="$refs.popover.closePopover" :options="sortedAuthOrganisationsList(lead.lead_auth_organisation)"
                               :close-on-select="true" label="name" track-by="id" :searchable="true"
                               @select="linkAuthOrganisation(lead.id, $event)" 
                               @remove="unlinkAuthOrganisation(lead.id)"
                               placeholder="Select organisation to link...">
                            </VueMultiselect>
                      </td>
 
                      <td>
                         <button type="button" class="btn btn-circle ms-1" @click="onButtonClick('view',lead.id)" 
                            data-bs-toggle="offcanvas" data-bs-target="#leadSidebar" aria-controls="leadSidebar"
                            style="padding:0px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 100 100" fill="none">
                               <path d="M14.8525 17C13.8933 17 13.1166 16.216 13.1166 15.25V10.75C13.1166 10.2859 13.2995 9.84076 13.625 9.51257C13.9506 9.18438 14.3921 9.00001 14.8525 9.00001H26.2601C26.7205 9.00001 27.162 9.18438 27.4876 9.51257C27.8131 9.84076 27.996 10.2859 27.996 10.75V15.25C27.996 16.216 27.2183 17 26.2601 17H14.8525ZM9.1487 15.101L9.1487 9.75001C9.14876 9.55998 9.22037 9.37707 9.34905 9.23822C9.47774 9.09937 9.65391 9.01493 9.84197 9.00198C10.03 8.98903 10.216 9.04852 10.3622 9.16844C10.5084 9.28836 10.604 9.45976 10.6297 9.64801L10.6367 9.75001L10.6367 15.088C10.1475 14.9655 9.63563 14.97 9.1487 15.101ZM14.8525 15.5L26.2601 15.5C26.3259 15.5 26.3889 15.4737 26.4355 15.4268C26.482 15.3799 26.5081 15.3163 26.5081 15.25L26.5081 10.75C26.5081 10.612 26.397 10.5 26.2601 10.5H14.8525C14.7867 10.5 14.7237 10.5263 14.6771 10.5732C14.6306 10.6201 14.6045 10.6837 14.6045 10.75V15.25C14.6045 15.3163 14.6306 15.3799 14.6771 15.4268C14.7237 15.4737 14.7867 15.5 14.8525 15.5ZM9.89268 19.908C9.39071 19.908 8.9093 19.707 8.55436 19.3492C8.19942 18.9913 8.00001 18.506 8.00001 18C8.00001 17.494 8.19942 17.0087 8.55436 16.6508C8.9093 16.293 9.39071 16.092 9.89268 16.092C10.3946 16.092 10.8761 16.293 11.231 16.6508C11.5859 17.0087 11.7853 17.494 11.7853 18C11.7853 18.506 11.5859 18.9913 11.231 19.3492C10.8761 19.707 10.3946 19.908 9.89268 19.908ZM14.8565 27C13.8972 27 13.1205 26.216 13.1205 25.25V20.75C13.1205 20.2859 13.3034 19.8408 13.629 19.5126C13.9545 19.1844 14.3961 19 14.8565 19H26.2641C26.7245 19 27.166 19.1844 27.4916 19.5126C27.8171 19.8408 28 20.2859 28 20.75V25.25C28 25.6893 27.836 26.1126 27.5407 26.4357C27.2453 26.7588 26.8403 26.9581 26.4059 26.994L26.2641 27H14.8565ZM14.8565 25.5H26.2641L26.3206 25.493C26.375 25.4802 26.4235 25.4492 26.4583 25.4051C26.493 25.361 26.512 25.3063 26.5121 25.25V20.75C26.5121 20.612 26.401 20.5 26.2641 20.5H14.8565C14.7907 20.5 14.7276 20.5263 14.6811 20.5732C14.6346 20.6201 14.6085 20.6837 14.6085 20.75V25.25C14.6085 25.3163 14.6346 25.3799 14.6811 25.4268C14.7276 25.4737 14.7907 25.5 14.8565 25.5ZM9.89268 27C9.71273 27.0002 9.53879 26.9347 9.40309 26.8156C9.26739 26.6964 9.17913 26.5317 9.15466 26.352L9.1487 26.25V20.899C9.63562 21.0301 10.1476 21.0346 10.6367 20.912V26.25C10.6367 26.4489 10.5583 26.6397 10.4187 26.7803C10.2792 26.921 10.09 27 9.89268 27Z" fill="#00A0C1"/>
                            </svg>
                         </button>
                         <button type="button" class="btn btn-circle ms-1 position-relative" 
                            :class="{'btn-circle-success' : lead.has_uploaded_proposal, 'btn-circle-secondary': !lead.has_uploaded_proposal}"
                            data-bs-toggle="modal" data-bs-target="#leadProposals"
                            title="Click to view/upload proposals" @click="onButtonClick('proposal',lead.id)">
                            <i class="fa fa-file-contract"></i>
                            <span v-if="lead.has_uploaded_proposal" class="position-absolute top-0 start-100
                               translate-middle">
                               <span class="fa fa-circle-check"></span>
                               <span class="visually-hidden">has uploaded proposal</span>
                            </span>
                         </button>
                         <button type="button" class="btn btn-circle btn-circle-danger ms-1"
                            title="Click to delete" @click="onButtonClick('delete',lead.id)">
                            <i class="fa fa-xmark"></i></button>
                      </td>
                   </tr>
                </tbody>
             </table>
          </div>
 
          <!-- START -- PAGINATION -->
          <div class="row text-center">
 
             <div class="d-inline pagination">
                <a
                   @click="previousPage()"
                   style="margin-right: 8px; color: #00a0c1;"
                   :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                   :disabled="this.pagination.page == 1"
                >
                   <i class="fa fa-chevron-left"></i>
                </a>
                <span>
                   <strong>
                   <span> {{ paginationLabel }} of {{ this.pagination.totalItems }} </span>
                   </strong>
                </span>
                <a
                   @click="nextPage()"
                   style="margin-left: 8px; color: #00a0c1;"
                   :style="this.pagination.page == this.pagination.totalPages 
                      || this.pagination.totalItems == 0 ? 'color: #ccc;' : 'cursor: pointer;'"
                   :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0"
                >
                   <i class="fa fa-chevron-right"></i>
                </a>
             </div>
 
          </div>
          <!-- END -- PAGINATION -->
          
       </div>
    </div>
 
    <!-- ========== START - FORM ========== -->
    <div class="modal fade" id="leadForm" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" ref="leadForm"
       style="top: 2%;">
       <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content">
             <div class="modal-header justify-content-end">
                <div>
                   <button ref="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                   <!-- @click="resetForm()" -->
                </div>
             </div>
 
             <div class="modal-body">
                <LeadForm ref="leadFormRef" @onSubmit="init"/>
             </div>
          </div>
          
       </div>
    </div>
    <!-- ========== END - FORM ========== -->
 
    <!-- ========== START - FORM ========== -->
    <!-- <div class="modal fade" id="leadNotesForm" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" ref="leadNotesForm"
       style="top: 2%">
       <LeadNotesForm ref="leadNotesFormRef"/>
    </div> -->
    <!-- ========== END - FORM ========== -->
 
    <!-- ========== START - PROPOSAL ========== -->
    <div class="modal fade" id="leadProposals" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" ref="leadProposals"
       style="top: 2%">
       <Proposal ref="leadProposalsRef" @onUpdate="init" @onClose="init" :isProposalSentStatus="isLeadStatusProposalSent"/>
    </div>
    <!-- ========== END - PROPOSAL ========== -->
 
    <!-- ========== OFFCANVAS SIDEBAR ========== -->
    <div class="offcanvas offcanvas-end" tabindex="-1" id="leadSidebar" aria-labelledby="leadSidebar" ref="leadSidebarRef" style="width:700px">
       <router-view @onSubmit="getLeadsList()"></router-view>
    </div>
    <!-- ========== END - OFFCANVAS SIDEBAR ========== -->
 
    <!-- ========== POPOVER ========== -->
    <div id="popover" class="d-none" role="tooltip">
       <Popover ref="popover" @cancelChange="getLeadsList()" @onUploadProposal="toggleProposalUpload"/>
    </div>
    <!-- ========== END - POPOVER ========== -->
       
 </template>
 
 <script>
 import { Offcanvas } from 'bootstrap';
 import LeadForm from '@/components/Leads/LeadForm.vue';
 // import LeadNotesForm from '@/components/Leads/LeadNotesForm.vue';
 import Proposal from '@/components/Proposals/Proposal.vue';
 import Popover from '@/components/Leads/Popover.vue';
 import moment from "moment";
 import { debounce } from '@/plugins/helper.js'
 import VueMultiselect from 'vue-multiselect'
 import 'vue-multiselect/dist/vue-multiselect.css'
 import "@/assets/scss/vue-multiselect.scss";
 
 const NO_AUTH_ORG = 0
 const HAS_EXISTING_AUTH_ORG    = 1
 const MARKED_FOR_AUTH_CREATION = 2
 
 export default{
 
    components: {
       LeadForm,
       // LeadNotesForm,
       Proposal,
       Popover,
       VueMultiselect,
    },
    
    data(){
       return{
          headers: [
             { text: "Date Created", value: "dateCreated" },
             { text: "Block Name", value: "leadName" },
             { text: "Block Type", value: "leadType" },
             { text: "Block Use", value: "priority" },
             { text: "Is Default", value: "leadStatus" },
             { text: "Products Applicable", value: "authOrganisation" },
             { text: "Action", value: "action" },
          ],
          search: "",
          leads: [],
          pagination: {
             pageSize: 10,
             page: 1,
             totalItems: 0,
             totalPages: 1,
          },
          rowsPerPageList: [
             { text: "5", value: 5 },
             { text: "10", value: 10 },
             { text: "20", value: 20 },
          ],
          sortByList: [
             { text: "Newest", value: "id_desc" },
             { text: "Oldest", value: "id_asc" },
             { text: "Lead Name", value: "lead_name" },
             { text: "Priority", value: "priority" },
             { text: "Status", value: "status" },
          ],
          sortBy: "id_desc", //default option
          filterByPriority: "none",
          filterByStatus: "none",
          sorting: {
             field: "id",
             order: "desc",
             filter: "none"
          },
          isEditing: false,
          debounceFn: null,
          leadStatusTypes: [],
          leadPriorityTypes: [],
          isLeadStatusProposalSent: false,
          totalProposals: 0,
          markedForAuthCreationOption: {
             id: 'forCreationInAuth',
             name: 'Marked for creation in Auth'
          },
          authOrganisationsList: [],
          isViewSpamOnly: false,
       }
 
    },
 
    created() {
       this.init()
       
       // for setting the delay of calling the function when searching
       this.debounceFn = debounce(() => this.getLeadsList(), 500)
 
       //declare constants
       this.HAS_EXISTING_AUTH_ORG = HAS_EXISTING_AUTH_ORG
       this.MARKED_FOR_AUTH_CREATION = MARKED_FOR_AUTH_CREATION
    },
 
    mounted() {
       //if url has lead id, toggle sidebar
       if (this.$route.params.id != null) {
          new Offcanvas(this.$refs.leadSidebarRef).show()
          this.onToggleSidebar()
          this.$router.push({name: 'leads-view', params: { id: this.$route.params.id }})
       }
    },
 
    beforeUnmount() {
       this.$refs.popover.closePopover(this.$refs.popover);
    },
 
    computed: {
       paginationLabel() {
          var start =  Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
          var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
          
          return start + " - " + end
       },
 
       currentPage() {
          return this.pagination.page
       },
 
       rowsPerPage() {
          return this.pagination.pageSize
       },
 
       sortItems() {
          return this.sortBy
       },
 
       filterItems() {
          if(this.sortBy == "priority") {
             return this.filterByPriority
          } else if(this.sortBy == "status") {
             return this.filterByStatus
          }
 
          return "none"
       },
 
       viewSpamLeads() {
          return this.isViewSpamOnly
       }
 
    },
 
    watch: {
       currentPage() {
          this.getLeadsList()
       },
 
       rowsPerPage() {
          this.pagination.page = 1
          this.getLeadsList()
       },
 
       sortItems() {
 
          if (this.sortBy == "id_asc" ) {
             this.sorting.field = "id"
             this.sorting.order = "asc"
             this.filterByPriority = "none"
             this.filterByStatus = "none"
          } else if (this.sortBy == "lead_name") {
             this.sorting.field = "organisation_name"
             this.sorting.order = "asc"
             this.filterByPriority = "none"
             this.filterByStatus = "none"
          } else if (this.sortBy == "priority" || this.sortBy == "status") {
             this.sorting.field = this.sortBy
             this.sorting.order = ""
             this.filterByPriority = "none"
             this.filterByStatus = "none"
          }
 
          this.sorting.filter = "none"
 
          this.getLeadsList()
       },
 
       filterItems() {
          if (this.sortBy == "priority" || this.sortBy == "status") {
             this.sorting.field = this.sortBy
             this.sorting.order = ""
             this.sorting.filter = (this.sortBy == "priority") ? this.filterByPriority : this.filterByStatus 
          } else {
             this.sorting.filter = "none"
          }
 
          this.getLeadsList()
       },
 
       viewSpamLeads() {
          this.pagination.page = 1
          this.getLeadsList()
       }
    },
 
    methods: {
 
       init() {
          // this.getAuthOrganisations()
          this.getLeadsList()
          this.getLeadStatusList()
          this.getLeadPriorityList()
 
          if (this.$refs.closeModal) {
             this.$refs.closeModal.click();
          }
          
       },
 
       onButtonClick(action, id){
          if(action=="create"){
             this.$refs.leadFormRef.isCreate()
          } else if(action=="edit"){
             this.$refs.leadFormRef.isEdit(id)
          } else if(action=="delete"){
             this.$refs.leadFormRef.isDelete(id)
          // } else if(action=="note"){
             // this.$refs.leadNotesFormRef.init(id)
          } else if(action=="view"){
             this.onToggleSidebar()
             this.$router.push({name: 'leads-view', params: { id: id }})
          } else if(action=="proposal"){
             this.$refs.leadProposalsRef.init(id)
          }
       },
 
       onToggleSidebar(){
          //when sidebar is hidden, change the url to leads
          this.$refs.leadSidebarRef.addEventListener('hidden.bs.offcanvas', () => {
             this.$router.push({name: 'leads'})
          });
       },
 
       onSearch() {
          this.debounceFn()
          this.pagination.page = 1
       },
 
       toggleProposalUpload({id}){
          this.isLeadStatusProposalSent = true
          this.$refs.leadProposalsRef.showModal(this.$refs.leadProposals)
 
          this.$refs.leadProposals.addEventListener('hidden.bs.modal', () => {
             this.isLeadStatusProposalSent = false
          });
 
          this.$refs.leadProposalsRef.init(id)
       },
 
       async getLeadsList() {
          let apiPath = "/leads?pageSize="+this.pagination.pageSize+"&page="+this.pagination.page
 
          console.log(this.sorting.filter)
 
          if (this.sortBy != "dateCreated_desc") {
 
             if(this.sorting.field == "priority" && this.filterByPriority != "none") {
                apiPath += "&sort="+this.sorting.field+"&filter_by_priority="+this.sorting.filter
             } else if(this.sorting.field == "status" && this.filterByStatus != "none") {
                apiPath += "&sort="+this.sorting.field+"&filter_by_status="+this.sorting.filter
             } else {
                apiPath += "&sort="+this.sorting.field
             }
             
             if (this.sorting.order != "") {
                apiPath +=  "&order="+this.sorting.order
             } 
          }
 
          if (this.search != "") {
             //encode + sign with %2B
             let encodedStr = this.search.replaceAll("+", "%2B")
             apiPath += "&query="+encodedStr
          }
 
          //check first if there are auth organisation list
          if (this.authOrganisationsList.length < 1) {
             await this.getAuthOrganisations()
          }
 
          await this.$axios.get(apiPath)
          .then((response) => {
 
             //console.log(response.data.leads)
 
             // map auth organisations for display
             response.data.leads.forEach((lead) => {
             
                if (lead.has_auth_organisation == HAS_EXISTING_AUTH_ORG) {
                   lead.lead_auth_organisation = this.authOrganisationsList.reduce((auth, {id, name}) => id == lead.auth_organisation_id ? auth = {id, name} : auth, {})
                   // lead.lead_auth_organisation = this.authOrganisationsList.filter(e => {return e.id == lead.auth_organisation_id}).map(({id,name}) => ({id,name}))
                } else if (lead.has_auth_organisation == MARKED_FOR_AUTH_CREATION) {
                   // lead.lead_auth_organisation = this.authOrganisationsList.filter(e => {return e.id == "forCreationInAuth"}).map(({id,name}) => ({id,name}))
                   lead.lead_auth_organisation = this.authOrganisationsList.reduce((auth, {id, name}) => id == "forCreationInAuth" ? auth = {id, name} : auth, {})
                } else if (lead.has_auth_organisation == 0 || lead.has_auth_organisation == null) {
                   lead.lead_auth_organisation = null
                }
             })
 
             this.leads = response.data.leads
             this.pagination.totalItems = response.data.total_items
             this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
 
       },
 
       formatDate(date){
          return moment(date).format("DD-MMM-YYYY")
       },
 
       previousPage(){
          this.pagination.page > 1 ? this.pagination.page -= 1 : ''
       },
 
       nextPage() {
          this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
       },
 
       priorityClass(value){
          let priority = this.leadPriorityTypes.filter((p) => { return p.id == value } ).map((e) => e.name)
 
          return priority.toString().toLowerCase()
       },
 
       async leadStatusChange(e, leadId, statusId){
 
          //check if it has proposal file uploaded before changing to Proposal Sent
          if (statusId == this.getLeadStatusId('ProposalSent')) {
             await this.$refs.leadProposalsRef.hasUploadedProposal(leadId)
                                  .then((response) => this.totalProposals = response)
          }
          
          if (statusId == this.getLeadStatusId('Lost')) {
             this.$refs.popover.showPopover(e.target, leadId, statusId, "lostLead");
          } else if (statusId == this.getLeadStatusId('ProposalSent') && this.totalProposals < 1) {
             this.$refs.popover.showPopover(e.target, leadId, statusId, "proposalSent");
          // } else if (statusId == this.getLeadStatusId('Spam')) {
          //    this.$refs.popover.showPopover(e.target, leadId, statusId, "spamLead");
          } else {
             this.$refs.popover.showPopover(e.target, leadId, statusId, "statusUpdate");
             // this.updateLeadStatus(leadId, statusId)
          }
       },
 
       //retrieve id of lead status
       getLeadStatusId(statusName){
          return this.leadStatusTypes.filter(e => {return e.name == statusName}).map(e => (e.id)).toString()
       },
 
       // async updateLeadStatus(leadId, statusId) {
         
       //    let lead = {
       //       lead_status_id : statusId,      
       //    }
  
       //    await this.$axios.put("/leads/"+leadId+"/status", lead)
       //    .then((response) => {
       //       if(response.data.success){
       //          this.$toast.success(response.data.message)
 
       //          this.getLeadsList();
       //       } else {
       //          this.$toast.error(response.data.message)
       //       }
       //    })
       //    .catch((error) => {
       //       this.$toast.error(error.response.data.message)
       //    })
          
       // },
 
       async updateLeadPriority(e, leadId, priorityId) {
 
          this.$refs.popover.showPopover(e.target, leadId, '', false);
          
          let lead = {
             lead_priority_id : priorityId,      
          }
          
          await this.$axios.put("/leads/"+leadId+"/priority", lead)
          .then((response) => {
             if(response.data.success){
                this.$toast.success(response.data.message)
 
                this.getLeadsList();
             } else {
                this.$toast.error(response.data.message)
             }
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
          
       },
 
       async getLeadStatusList(){
          await this.$axios.get("/categories?name=LeadStatus")
          .then((response) => {
             this.leadStatusTypes = response.data.category.subcategories
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
       },
 
       async getLeadPriorityList(){
          await this.$axios.get("/categories?name=LeadPriority")
          .then((response) => {
             this.leadPriorityTypes = response.data.category.subcategories
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
       },
 
       // Call get organisations from Auth
       async getAuthOrganisations(){
          await this.$axios_auth.get("/vertex/organisations")
          .then((response) => {
             this.authOrganisationsList = response.data.organisations
             this.authOrganisationsList.unshift(this.markedForAuthCreationOption)
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
       },
 
       async linkAuthOrganisation(leadId, e) {
          let authOrganisationId = e.id
 
          let lead = {
             auth_organisation_id : parseInt(authOrganisationId),
             has_auth_organisation : HAS_EXISTING_AUTH_ORG,
             auth_organisation_name : e.name
          }
 
          if (authOrganisationId == "forCreationInAuth") {
             lead.auth_organisation_id = 0
             lead.has_auth_organisation = MARKED_FOR_AUTH_CREATION
          }
          
          await this.$axios.put("/leads/"+leadId+"/auth/organisation", lead)
          .then((response) => {
             if(response.data.success){
                this.$toast.success(response.data.message)
 
                this.getLeadsList();
             } else {
                this.$toast.error(response.data.message)
             }
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
       },
 
       async unlinkAuthOrganisation(leadId) {
 
          let lead = {
             auth_organisation_id : 0,
             has_auth_organisation : NO_AUTH_ORG
          }
 
          await this.$axios.put("/leads/"+leadId+"/auth/organisation", lead)
          .then((response) => {
             if(response.data.success){
                this.$toast.success(response.data.message)
 
                this.getLeadsList();
             } else {
                this.$toast.error(response.data.message)
             }
          })
          .catch((error) => {
             this.$toast.error(error.response.data.message)
          })
       },
 
       sortedAuthOrganisationsList(leadOrgId) {
          //move dropdown scroll to top
          let multiselect = document.querySelectorAll(".multiselect__content-wrapper")
          multiselect.forEach((sel) => sel.scrollTop = 0)
 
          //move selected option at the top of list
          if (leadOrgId != null && leadOrgId.id > 0) {
             
             let orgList = this.authOrganisationsList.map((obj) => {return obj})
 
             let orgIndex = orgList.findIndex(org => org.id == leadOrgId.id)
             let selectedOrg = orgList.filter(org => {return org.id == leadOrgId.id})
             
             orgList.splice(orgIndex, 1)
             orgList.unshift(selectedOrg[0])
 
             return orgList
          } else {
             return this.authOrganisationsList
          }
          
       },
    }
 
 }
 
 </script>
 
 <style>
 
 .high{
    color: #EB1C24;
 }
 
 .low{
    color: #00A54F;
 }
 
 .medium{
    color: #F3994D;
 }
 
 .clickable-row { 
    cursor: pointer;
 }
 
 td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
 }
 
 .table-select {
    padding-left: 5px;
    margin-right: 0;
    cursor: pointer;
    border: none;
    height: 45px;
    width: auto;
 }
 
 .table-select:not(.high, .low, .medium) {
    color: #435666;
 }
 
 .table-select>option{
    color: #212529;
 }
 
 .table-select:not(:hover) {
    background: none;
 }
 
 .auth-org-select {
    padding: .375rem 2.25rem .375rem 5px;
    display: block;
    width: auto;
    font-size: 1rem;
    font-weight: 400;
    color: #435666;
    border: none;
    height: 45px;
    background: none;
    min-height: unset;
    text-align: start;
    align-items: center;
 }
 
 .auth-org-select .multiselect__tags {
    width: auto;
    height: auto;
    color: #435666;
    border: none;
    padding: .375rem 0 .375rem 0;
 }
 
 .auth-org-select .multiselect__placeholder, .multiselect--active {
    width: auto;
    margin: 0px;
    padding: .375rem 0 .375rem 0;
    color: #435666;
 }
 
 .auth-org-select .multiselect__single{
    margin: 0px;
    padding: .375rem 0 .375rem 0;
    line-height: 1;
    width: auto;
 }
 
 .auth-org-select .multiselect__input{
    /* padding: 0px; */
    line-height: 1;
    padding: .375rem 0 .375rem 5px;
    margin: 0px;
 }
 
 </style>